import Link from 'next/link';
import Image from 'next/image';

import * as Slider from '@radix-ui/react-slider';
import { Button } from '@/components/button';
import { cn } from '@/utils/cn';

import Icons from './Icons';

interface ProgressCardProps {
  isLevelUp: boolean;
  status: string;
  level: number;
  totalPoints: number;
  maxPoints: number;
}

const ProgressCard: React.FC<ProgressCardProps> = ({ isLevelUp, status, level, totalPoints, maxPoints }: ProgressCardProps) => {
  return (
    <div className='hidden xl:flex flex-col w-fit h-full bg-surface-primary rounded-2xl border-2 border-border-primary'>
      <div className='flex flex-1 items-center gap-6 py-4 px-8'>
        <div className={cn('hidden 2xl:flex flex-col gap-1', isLevelUp ? 'xl:flex' : 'hidden')}>
          <p className='text-xl text-text-secondary leading-none'>Current status</p>
          <p className='text-xl font-medium text-text-primary leading-none'>{status}</p>
        </div>
        <div className={cn('hidden 2xl:flex flex-col gap-1', isLevelUp ? 'xl:flex' : 'hidden')}>
          <p className='text-xl text-text-secondary leading-none'>Level</p>
          <p className='text-xl font-medium text-text-primary leading-none'>{level}</p>
        </div>
        {isLevelUp ? (
          <Link href='/quanta'>
            <Button
              variant='primary'
              trailingIcon={
                <div className='hidden 1320:block'>
                  <Icons.LevelUp />
                </div>
              }
            >
              Level Up
            </Button>
          </Link>
        ) : (
          <div className='flex flex-col gap-1'>
            <div className='flex items-center justify-between gap-10 w-[300px]'>
              <p className='text-xl text-text-secondary leading-none'>Progress</p>
              <div className='flex items-center gap-1'>
                <span className='font-semibold text-text-primary leading-[20px]'>
                  {totalPoints} / {maxPoints}
                </span>
                <Image src='/assets/quanta/quanta-points.png' alt='Quanta Points' width={16} height={16} />
              </div>
            </div>
            <Slider.Root className='flex items-center w-full py-[1px] select-none' value={[totalPoints]} max={maxPoints} step={1} disabled>
              <Slider.Track className='relative h-[18px] grow rounded-full bg-surface-secondary'>
                <Slider.Range
                  className={cn('absolute h-full rounded-l-full bg-text-primary', totalPoints >= maxPoints && 'rounded-r-full')}
                />
              </Slider.Track>
            </Slider.Root>
          </div>
        )}
      </div>
    </div>
  );
};

export default ProgressCard;
